import { uncutPoints } from "@/mocks/siteContent";

export default function UncutSection() {
  return (
    <section id="uncut" className="w-full bg-background-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium text-accent-300 bg-background-50/10 px-3 py-1 rounded-full mb-4">
            <i className="ri-scissors-cut-line" aria-hidden="true"></i>
            未删减看点对比
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">
            「未删减」到底多了什么
          </h2>
          <p className="mt-4 text-sm md:text-base text-background-200/85 leading-relaxed">
            最容易踩的坑，是把营销话术当成事实。不同平台、不同地区的版本，实际增减的内容差别很大。下面列出这类题材里「未删减版」通常涉及的方向，帮你建立判断框架。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {uncutPoints.map((item, idx) => (
            <article
              key={item.title}
              className="bg-background-50/[0.06] rounded-lg p-5 md:p-6 border border-background-50/12"
            >
              <div className="flex items-center gap-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-500 text-background-950 font-heading font-bold text-sm">
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <h3 className="font-heading text-base md:text-lg font-bold text-background-50">{item.title}</h3>
              </div>
              <p className="mt-3 text-sm text-background-200/80 leading-relaxed">{item.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 flex items-start gap-3 bg-primary-500/15 border border-primary-400/30 rounded-lg p-5">
          <i className="ri-alert-line text-accent-300 text-xl mt-0.5 shrink-0" aria-hidden="true"></i>
          <p className="text-sm text-background-100/90 leading-relaxed">
            <strong className="font-semibold text-background-50">提醒：</strong>
            判断是否真的「未删减」，建议以官方公布的正片时长、分级信息和片源说明为准，而不是只凭标题里出现的字样下结论。具体到某一部作品，请以官方信息为准。
          </p>
        </div>
      </div>
    </section>
  );
}